import { render, staticRenderFns } from "./RecordNameSetup.vue?vue&type=template&id=79a2278b&scoped=true&"
import script from "./RecordNameSetup.vue?vue&type=script&lang=ts&"
export * from "./RecordNameSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a2278b",
  null
  
)

export default component.exports